import React from 'react'
import * as fs from 'node:fs'
import path from 'node:path'

type LoanApplicationPageProps = {
  html: string
}

// eslint-disable-next-line jsx-a11y/html-has-lang
const LoanApplicationPage = ({ html }: LoanApplicationPageProps) => <html dangerouslySetInnerHTML={{ __html: html }} />

LoanApplicationPage.getLayout = (page: React.ReactElement) => page

export default LoanApplicationPage

export const getStaticProps = () => {
  const file = path.resolve(process.cwd(), 'static-pages/loan-application.html')

  return {
    props: {
      html: fs.readFileSync(file, 'utf8'),
    },
  }
}
